import HubInterestMessageFooter from './HubInterestMessageFooter';
import { AnimatedMessaging } from 'signup-components/styles/MessagingAnimations.styles';
import { useIsFramedCentredStep } from '../hooks/useIsFramedCentredStep';
import { useOnImageLoaded } from '../images/useOnImageLoaded';
import { BaseMessageCaption } from './BaseMessageCaption';
import { getMessage } from './MESSAGE';
import { StyledIllustration, StyledMessagingIllustration } from './Messaging.styles';
import { isTransitionAndAnimationsDisabled } from '../selenium/seleniumFeatures';
import { jsx as _jsx } from "react/jsx-runtime";
const HubInterestLandingPage = ({
  messageKey
}) => {
  const {
    illustrationName,
    height
  } = getMessage(messageKey);
  const {
    imageLoaded,
    handleImageLoaded
  } = useOnImageLoaded(illustrationName);
  const {
    isFramedCentredStep
  } = useIsFramedCentredStep();
  return /*#__PURE__*/_jsx(AnimatedMessaging, {
    "data-test-id": "hub-interest-landing-page",
    disable: isTransitionAndAnimationsDisabled(),
    loaded: imageLoaded,
    children: /*#__PURE__*/_jsx(StyledIllustration, {
      isFramedCentredStep: isFramedCentredStep,
      messageKey: messageKey,
      children: /*#__PURE__*/_jsx(BaseMessageCaption, {
        footer: /*#__PURE__*/_jsx(HubInterestMessageFooter, {
          messageKey: messageKey
        }),
        messageKey: messageKey,
        textAlign: "left",
        children: /*#__PURE__*/_jsx(StyledMessagingIllustration, {
          height: height,
          name: illustrationName,
          onLoad: handleImageLoaded
        })
      })
    })
  });
};
export default HubInterestLandingPage;